export default __webpack_public_path__ + "static/media/handshake.b353521e.png";